import { Box, Grid, Heading, ResponsiveContext, Text } from "grommet";

// import { useNavigate } from "react-router-dom";
import { useContext } from "react";
// import groupPic from "../assets/founderssilly.jpg";
import ProfileCard from "../components/ProfileCard";
import colors from "../colors";
import { useAppContext } from "../stateManager/useAppContext";

const PhotoBanner = ({ groupPic }) => {
  const viewportSize = useContext(ResponsiveContext);
  const { siteData } = useAppContext();
  return (
    <Box
      fill="horizontal"
      background={
        "linear-gradient(" + colors.dark + " -50%, " + colors.light + " 100%);"
      }
      align="center"
    >
      <Box pad={{ vertical: "small" }}>
        <Box width={"large"} alignSelf="center" gap={"medium"}>
          <Text
            textAlign="center"
            size={viewportSize === "small" ? "2xl" : "4xl"}
            weight={500}
            // color="light-1"
            // style={{ textShadow: "2px 2px 4px #000000" }}
          >
            {siteData.teamPage.title}
          </Text>
        </Box>
      </Box>
      <Box pad={"medium"}>
        <Box
          width={"large"}
          height="medium"
          // alignSelf="center"
          gap={"medium"}
          background={{ image: "url(" + groupPic + ")", position: "50% 20%" }}
          pad={"large"}
          round={"small"}
        ></Box>
      </Box>
    </Box>
  );
};

const GroupSection = ({ groupLabel, teamMembers }) => {
  // const navigate = useNavigate();
  return (
    <Box pad={"large"} gap={"medium"}>
      <Heading size="small" alignSelf="center">
        {groupLabel}
      </Heading>
      <Grid columns="medium" gap="large">
        {teamMembers.map((teamMember, i) => {
          return <ProfileCard teamMember={teamMember} key={"profile_" + i} />;
        })}
      </Grid>
    </Box>
  );
};

const TeamPage = () => {
  const { siteData } = useAppContext();
  const founders = siteData
    ? siteData.providers.filter((e) => e.type === "founder")
    : [];
  const counselors = siteData
    ? siteData.providers.filter((e) => e.type === "counselor")
    : [];
  if (!siteData) return null;
  return (
    <Box>
      <PhotoBanner groupPic={siteData.teamPage.groupPictureUrl} />
      <GroupSection groupLabel="Aitapissko Founders" teamMembers={founders} />
      {counselors.length > 0 && (
        <GroupSection
          groupLabel="Counselors who Share our Space"
          teamMembers={counselors}
        />
      )}
    </Box>
  );
};
export default TeamPage;
